module.exports = __webpack_public_path__ + "img/continue-button.1d149cfa.png";